/**
 * Google Ads conversion events (gtag.js, tag AW-18306058215 loaded in index.html).
 * Consent Mode v2 gates cookies automatically; events fire cookieless if denied.
 * Optional per-conversion labels (from Google Ads UI) via env:
 *   REACT_APP_GADS_LABEL_SIGNUP, REACT_APP_GADS_LABEL_LEAD
 */
const ADS_ID = "AW-18306058215";

const LABELS = {
  sign_up: process.env.REACT_APP_GADS_LABEL_SIGNUP,
  generate_lead: process.env.REACT_APP_GADS_LABEL_LEAD,
};

export function trackAdsConversion(name, params = {}) {
  try {
    if (typeof window.gtag !== "function") return;
    window.gtag("event", name, params);
    const label = LABELS[name];
    if (label) {
      window.gtag("event", "conversion", { send_to: `${ADS_ID}/${label}`, ...params });
    }
  } catch {
    /* never break the app for tracking */
  }
}
